import { Store } from 'src/store/index';

const isLowDPIWarningEnabled = (store: Store) => store.design.isLowDPIWarningEnabled;

export default isLowDPIWarningEnabled;
